import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { JobOfferContext } from "./context";
import { Buttons, Field, Footer, Icon, Infos, Skill } from "./joboffer.styled";
import { Button } from "../common";
import { useTheme } from "styled-components";
import { commonApi } from "../../api/talent/common-service";

const JobOfferDetails: React.FC<{
  handleOpenEdit: () => void;
  onDismiss: () => void;
  onConfirm: () => void;
}> = ({ handleOpenEdit, onDismiss, onConfirm }) => {
  const { t } = useTranslation("private-home-page");
  const [workplace, setWorkplace] = useState<string | null>(null);
  const handleClick = () => {
    handleOpenEdit();
  };
  const theme = useTheme();

  const {
    joinTextWorkType,
    joinTextSalary,
    joinTextCurrency,
    joinTextLanguage,
    joinTextLanguageLevel,
    jobofferform,
  } = useContext(JobOfferContext);

  useEffect(() => {
    if(jobofferform?.workplace){
      const id = parseInt(jobofferform?.workplace);
      if(!isNaN(id)){
        commonApi.fetchCityById(id).then((res) => {
          setWorkplace(res.data.label);
        });
      } else {
        setWorkplace(jobofferform?.workplace);
      }
    }
  }, [jobofferform?.workplace, setWorkplace]);

  return (
    <>
      <Infos>
        <Skill>
          <p>{`${t("jobOffer.modal.coreTechnology")} ${
            jobofferform?.ecosystem ? jobofferform.ecosystem.name : "Java"
          }`}</p>
          <Icon>
            <img
              src="/assets/img/pencil-icon.svg"
              alt=""
              onClick={() => handleClick()}
            />
          </Icon>
        </Skill>
        <Field>
          <p>{`${t("jobOffer.modal.currency")} ${joinTextCurrency(
            jobofferform?.currency
          )}`}</p>
        </Field>
        <Field>
          <p>{`${t("jobOffer.modal.salary")} ${joinTextSalary(
            jobofferform?.salary
          )}`}</p>
        </Field>
        <Field>
          <p>
            {`${t("jobOffer.modal.hireType")} ${joinTextWorkType(
              jobofferform?.hireTypes
            )}`}
          </p>
        </Field>
        <Field>
          <p>
            {`${t("jobOffer.modal.workType")} ${joinTextWorkType(
              jobofferform?.workType
            )}`}
          </p>
        </Field>
        <Field>
          <p>
            {`${t("jobOffer.modal.language")} ${joinTextLanguage(
              jobofferform?.language
            )}`}
          </p>
        </Field>
        <Field>
          <p>
            {`${t("jobOffer.modal.language_level")} ${joinTextLanguageLevel(
              jobofferform?.language_level
            )}`}
          </p>
        </Field>
        <Field>
          <p>
            {`${t("jobOffer.modal.city")} ${workplace ||
              t("private-home-page:jobOffer.modal.notInformed")
            }`}
          </p>
        </Field>
        <Field>
          <p>
            {`${t("jobOffer.modal.plus_info")} ${jobofferform?.plusInfo ||
              t("private-home-page:jobOffer.modal.notInformed")
            }`}
          </p>
        </Field>
      </Infos>
      <Footer>
        <Buttons>
          <Button
            backgroundColor={theme.colors.primaryBlue.main}
            textColor={theme.colors.primaryBlue.text}
            onClick={() => onDismiss()}
            width="fit-content"
            bordered={true}
          >
            {t("jobOffer.buttons.cancel")}
          </Button>
          <Button
            backgroundColor={theme.colors.primaryBlue.main}
            textColor={theme.colors.primaryBlue.text}
            onClick={() => onConfirm()}
            width="fit-content"
          >
            {t("jobOffer.buttons.submit")}
          </Button>
        </Buttons>
      </Footer>
    </>
  );
};

export default JobOfferDetails;
